@if (topheadline | async ; as item) {
  <div class="container carousel_Heading_Container">
    <div class="col-sm-12 text-center">
      <h2 class="head-line">{{item.headLine}}</h2>
      <p class="text-center top-text">{{item.Text1}}</p>
      <div class="row-flex large-carousel-desktop-row">
      </div>
    </div>
  </div>
}
<div class="container supply_chain_carousel_container desktop_Supply_Chain">
  <div id="custom-Carousel" class="carousel slide desktop-carousel supply_chain_destop_carousel"
    data-bs-ride="carousel">
    <!--Button container for US-->
    <div class="large--carousel-btn-container us_Carousel_Btn_Container">
      <button class="custom-carousel-control-btn custom-carousel-control-prev" type="button"
        (click)="goprevious()">
        <span class="custom-icon prev-icon">
          <img alt="Navigate to previous arrow" src="assets/images/prev-btn.svg">
        </span>
      </button>
      <button class="custom-carousel-control-btn custom-carousel-control-next" type="button" (click)="gonext()">
        <span class="custom-icon next-icon">
          <img alt="Navigate to next arrow" src="assets/images/next-btn.svg">
        </span>
      </button>
    </div>
    <div class="carousel-inner">
      @for (item of mergedObject1; track item; let i = $index) {
        <div class="carousel-item1 supply_chain_carousel"
          [ngClass]="{'active': activeIndex1 === i}">
          <div class="row slide--content d-flex">
            <div class="col-lg-4 col-md-6 col-sm-12 left-column">
              <div class="h2" [innerHTML]="item.headline"></div>
              <p>{{item.largeparagraphcontent}}</p>
              <!-- <a (click)="downloadFile()">{{item.h2content}}</a> -->
              <a class="downloadLink" [href]="getpdf(item.pdfMedia)">{{item.h2content}}<img alt="Download"
              src="../../../app/../assets/images/download.png"></a>
              <a class="navigateLink" href="{{item.urlLink}}" target="_blank">{{item.h2content}}<img
              alt="Next screen" src="../../../app/../assets/images/blackarrow.png"></a>
            </div>
            <div class="col-lg-8 col-md-6 col-sm-12 right-column">
              <img [src]="getImage(item.media)" [attr.alt]="item.media?.altText" class="d-block w-100">
            </div>
          </div>
        </div>
      }
      <!--button container for UK-->
      <div class="large--carousel-btn-container uk_Carousel_Btn_Container">
        <button class="custom-carousel-control-btn custom-carousel-control-prev" type="button" (click)="goprevious()">
          <span class="custom-icon prev-icon">
            <img alt="Navigate to previous arrow" src="assets/images/prev-btn.svg">
          </span>
        </button>
        <button class="custom-carousel-control-btn custom-carousel-control-next" type="button" (click)="gonext()">
          <span class="custom-icon next-icon">
            <img alt="Navigate to next arrow" src="assets/images/next-btn.svg">
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
<div id="about-Locations" class="row-flex carousel--three-card resources-card--row about_Locations_Mobile d-none">
  <div id="resourcesCarousel" class="carousel slide" data-bs-ride="false">
    <ol class="carousel-indicators">
      @for (data1 of mergedObject1; track data1; let i = $index) {
        <li [attr.data-bs-target]="'#resourcesCarousel'"
        [attr.data-bs-slide-to]="i" [class.active]="i === 0"></li>
      }
    </ol>
    <div class="carousel-inner">
      @for (data1 of mergedObject1; track data1; let i = $index) {
        <div class="carousel-item" [class.active]="i === 0">
          <div class="resources--card col-md-7">
            <img [src]="getImage(data1?.media)" [alt]="data1?.media?.altText" class="card-img">
          </div>
          <div class="bottom-row">
            <div class="bottom-row-content">
              <h2 [innerHTML]="data1.headline"></h2>
              <p [innerHTML]="data1.largeparagraphcontent"></p>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="large--carousel-btn-container mobile-carousel-btn-container">
      <div class="custom-carousel-control-btn custom-carousel-control-prev" type="button" (click)="prevSlide()">
        <span class="custom-icon prev-icon">
          <img alt="Navigate to previous arrow" src="assets/images/prev-btn.svg" class="previous_Img">
        </span>
      </div>
      <div class="custom-carousel-control-btn custom-carousel-control-next" type="button" (click)="nextSlide()">
        <span class="custom-icon next-icon">
          <img alt="Navigate to previous arrow" src="assets/images/next-btn.svg" class="next_Img">
        </span>
      </div>
    </div>
  </div>
  <div class="row-flex world-carousel-mobile-cta cta-mobile-width">
    <div class="col-flex-lg-12 col-flex-md-12 col-flex-sm-12 col-flex-xs-12">
      <a href="{{mergedObject1[0]?.urlLink}}" target="_blank">{{mergedObject1[0]?.h2content}}<img alt="Next screen" src="../../../app/../assets/images/blackarrow.png"></a>
    </div>
  </div>
</div>